import { CircularLoaderContainer } from '@components/base/circular-loader-container.component.tsx';
import PrivateRoute from '@components/private-route.component.tsx';
import { createBrowserRouter, Outlet, useLocation } from 'react-router-dom';
import AuthRouter from '../modules/auth/auth.router.tsx';
import { AuthPartnerSelectPage } from '../modules/auth/pages/auth-partner-select.page.tsx';
import ExternalRouter from '../modules/external/external.router.tsx';
import InternalV2Router from '../modules/internal-v2/internal-v2.router.tsx';
import { NotFoundErrorPage } from '@/components/not-found-error.page.tsx';
import { UnsubscribePage } from '@/components/unsubscribe.page.tsx';
import { AuthImpersonatePage } from '@/modules/auth/pages/auth-impersonate.page.tsx';
import { CookieConsentBanner } from '@components/cookie-banner/cookie-consent-banner.tsx';
import { SourcingPortalPage } from '../modules/sourcing-portal/sourcing-portal.page.tsx';
import { MaintenanceGate } from '@components/announcements/maintenance-gate.component.tsx';

/**
 * App-wide layout. Renders the cookie consent banner on every route except the
 * internal admin pages (`/i/*`) — those are employee-only and don't show it.
 * The {@link MaintenanceGate} wraps everything so a maintenance toggle blocks
 * external users globally (internal users bypass it).
 */
function RootLayout() {
  const { pathname } = useLocation();
  const isInternal = pathname === '/i' || pathname.startsWith('/i/');

  return (
    <MaintenanceGate>
      {!isInternal && <CookieConsentBanner />}
      <Outlet />
    </MaintenanceGate>
  );
}

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        path: '*',
        element: <NotFoundErrorPage />,
      },
      {
        path: '/email/unsubscribe/:token',
        element: <UnsubscribePage />,
      },
      {
        path: '/sourcing/:token',
        element: <SourcingPortalPage />,
      },
      {
        path: '/',
        element: <PrivateRoute />,
        loader: () => <CircularLoaderContainer />,
        children: [
          {
            index: true,
            element: <AuthPartnerSelectPage />,
          },
          {
            path: '/impersonate',
            element: <AuthImpersonatePage />,
          },
        ],
      },
      {
        path: '/bp/*',
        element: <ExternalRouter />,
      },
      {
        path: '/i/*',
        element: <InternalV2Router />,
      },
      {
        path: '/auth/*',
        element: <AuthRouter />,
      },
    ],
  },
]);

export default router;
